// extracted by mini-css-extract-plugin
export default {"placeholder":"TextInput2_placeholder__1hP-r","textInput":"TextInput2_textInput__rhuD8"};